// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"880":"3ff45cdd7c1f6ebd","9728":"561717a81ff7b001"}[chunkId] + ".css";
};